import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_v7rb5sedtf: FaireBrandEntity = {
  token: "b_v7rb5sedtf",
  type: "brand",
  name: "Le Toy Van, Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/414a93dcf19460301e71e1d0e41f6c8c2b3f0f43df9fe7394a4a9bdeebc6a466.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c268cf12e3086a5555386c11473ac5112d3f7f70f72822b294127cafc65917b6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/414a93dcf19460301e71e1d0e41f6c8c2b3f0f43df9fe7394a4a9bdeebc6a466.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c268cf12e3086a5555386c11473ac5112d3f7f70f72822b294127cafc65917b6.jpeg",
  location: "GRANTSVILLE, MD, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 42,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 1995, Le Toy Van is a family-owned designer and maker of FSC®-certified wooden toys that inspire learning and play. \n\nEach toy is crafted with care from sustainable, high-quality materials for lasting fun. \n\nDesigned in line with the EYFS Framework, our toys nurture creativity, imagination, and development in babies, toddlers and children. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:34.497Z",
    importedBy: "entity-db-cli",
  },
};
